import type { KinerjaSelection } from 'types/kinerja'
import type { KinerjaKsUtamaDetail } from 'types/kinerja-ks'

export const mapKuantitas = (
  options: Array<KinerjaKsUtamaDetail>,
  value: KinerjaSelection | null | undefined
): KinerjaKsUtamaDetail | null => {
  if (value == null) return null

  const kinerja = options.find((option) => option.id === value.id)

  if (!kinerja) return null

  return {
    ...kinerja,
    targetKuantitas: kinerja.targetKuantitasMin
      ? `${value.kuantitas} kegiatan`
      : kinerja.targetKuantitas,
  }
}
